import React, { PureComponent } from 'react'

import PresentationalQuizPage from '../../components/pages/PresentationalQuizPage'
import { QuizType } from '../../../commons/EditorStatus'
import * as QuizPhase from '../../../commons/QuizPhase'
import { buildOtherUrl } from '../../../commons/utils'

class DemoPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      time: 0,
      interval: null,
      choicedId: null
    }
  }

  componentDidMount() {
    this.setState({
      interval: setInterval(() => {
        this.setState({
          time: this.state.time + 0.1
        })
      }, 100)
    })
  }

  componentWillUnmount() {
    clearInterval(this.state.interval)
  }

  render() {
    const demoQuestions = [
      {
        title: 'ふたりの初デートの場所は？',
        question_type: 0,
        limit_time: 10,
        choicedId: null,
        answerId: 2,
        choices: [
          {
            id: 1,
            title: '渋谷でお買い物',
            image: 'https://projects.ennoshita.app/images/initial_questions/landmark_hachikou.png'
          },
          {
            id: 2,
            title: '浅草寺',
            image: 'https://projects.ennoshita.app/images/initial_questions/kankou_kaminarimon.png'
          },
          {
            id: 3,
            title: '池袋の水族館',
            image: 'https://projects.ennoshita.app/images/initial_questions/building_suizokukan.png'
          },
          {
            id: 4,
            title: '新宿の映画館',
            image: 'https://projects.ennoshita.app/images/initial_questions/kandou_movie_eigakan.png'
          }
        ]
      },
      {
        title: '付き合ったきっかけはユウからの告白である',
        question_type: 1,
        limit_time: 10,
        choicedId: null,
        answerId: 5,
        choices: [
          {
            id: 5,
            title: ''
          },
          {
            id: 6,
            title: ''
          }
        ]
      },
      {
        title: 'ユウの手料理でリョウタが好きなものは？',
        question_type: 0,
        limit_time: 10,
        choicedId: null,
        answerId: 10,
        choices: [
          {
            id: 7,
            title: 'カルボナーラ',
            image: 'https://projects.ennoshita.app/images/initial_questions/food_spaghetti_carbonara.png'
          },
          {
            id: 8,
            title: '肉じゃが',
            image: 'https://projects.ennoshita.app/images/initial_questions/bousai_nikujaga.png'
          },
          {
            id: 9,
            title: 'グリーンカレー',
            image: 'https://projects.ennoshita.app/images/initial_questions/green_curry.png'
          },
          {
            id: 10,
            title: '親子丼',
            image: 'https://projects.ennoshita.app/images/initial_questions/food_oyakodon.png'
          }
        ]
      }
    ].map(question => {
      if (process.env.NODE_ENV === 'development') {
        return question
      }

      const tmpQuestion = question
      tmpQuestion.choices = question.choices.map(choice => {
        const tmpChoice = choice
        tmpChoice.image = choice.image ? buildOtherUrl(choice.image) : choice.image
        return tmpChoice
      })
      return tmpQuestion
    })

    const { time, choicedId } = this.state
    const presentationalQuizPageProps = {
      type: QuizType.QUESTION.value,
      participantCount: 95,
      questions: demoQuestions,
      isAnswerSending: false,
      question: {},
      title: 'リョウタとユウのウェディングパーティー',
      postAnswer: ({ choiceId }) => this.setState({ choicedId: choiceId })
    }

    // index制御
    const QUIZ_CYCLE = 22
    const baseTime = time % QUIZ_CYCLE
    const index = Math.floor(time / QUIZ_CYCLE)
    presentationalQuizPageProps.index = index
    if (index < demoQuestions.length) {
      // 問題
      presentationalQuizPageProps.question = demoQuestions[index]
      presentationalQuizPageProps.question.choicedId = choicedId

      // phaseなどの制御
      if (baseTime >= 0 && baseTime < 2) {
        presentationalQuizPageProps.phase = QuizPhase.PREPARE
        this.setState({ choicedId: null })
      } else if (baseTime >= 2 && baseTime < 4) {
        presentationalQuizPageProps.phase = QuizPhase.QUESTION
      } else if (baseTime >= 4 && baseTime < 14) {
        presentationalQuizPageProps.phase = QuizPhase.START
        presentationalQuizPageProps.time = 14 - baseTime
      } else if (baseTime >= 14 && baseTime < 15) {
        presentationalQuizPageProps.phase = QuizPhase.TIMEOUT
      } else if (baseTime >= 15 && baseTime < 17) {
        presentationalQuizPageProps.phase = QuizPhase.ANSWER_COUNT
        const answerCount = {}
        if (this.state.choicedId) {
          answerCount[this.state.choicedId] = 1
        }
        presentationalQuizPageProps.answerCount = answerCount
      } else if (baseTime >= 17 && baseTime < 19) {
        presentationalQuizPageProps.phase = QuizPhase.IS_ANSWER
      } else if (baseTime >= 19 && baseTime < 22) {
        presentationalQuizPageProps.phase = QuizPhase.RESULT
        const answerCount = {}
        if (this.state.choicedId) {
          answerCount[this.state.choicedId] = 1
        }
        presentationalQuizPageProps.answerCount = answerCount

        presentationalQuizPageProps.answerChoiceId = presentationalQuizPageProps.question.answerId
      }
    } else {
      // ランキング
      presentationalQuizPageProps.type = QuizType.RANKING.value
      const rankingIndex = index - demoQuestions.length

      if (baseTime > 3 || rankingIndex > 0) {
        presentationalQuizPageProps.name = 'ゲスト'
        presentationalQuizPageProps.resultName = 'ゲスト'
        presentationalQuizPageProps.resultRank = '1'
      }
    }

    return <PresentationalQuizPage {...presentationalQuizPageProps} />
  }
}

export default DemoPage
